import type Dict from '../i18n/en.json'
import {deepMerge} from './utils/deepMerge'

export let locales = [
  {code: 'en', name: 'English'},
  {code: 'uk', name: 'Українська'},
  {code: 'ru', name: 'Русский'}
]

const subdomain = window.location.hostname.split('.').slice(0, -2).join('.')

const localeBySubdomain = {
  ua: 'uk',
  ru: 'ru',
  '': 'en'
}[subdomain]

export const lang = localeBySubdomain

export let t = {} as typeof Dict

export async function initTranslations() {
  const englishFallback = await import('../i18n/en.json')
  t = deepMerge(englishFallback, await import(`../i18n/${lang}.json`))
}

export function replaceValues(text: string, values: Record<string, any>) {
  return text.replace(/%\{(.*?)}/g, (_, placeholder) => replacePlaceholder(placeholder, values))
}

export function replacePlaceholder(text: string, values: Record<string, any>) {
  const pluralTokens = text.split('|')
  const field = pluralTokens[0]
  if (pluralTokens.length == 1) return values[field] ?? field

  const key = new Intl.PluralRules(lang).select(values[field])
  const zeroKey = values[field] === 0 ? 'zero' : ''

  for (let i = 1; i < pluralTokens.length; i++) {
    const [candidateKey, candidateText] = pluralTokens[i].split(':', 2)
    if (candidateKey === key || candidateKey == zeroKey) return candidateText.replace('#', values[field])
  }
  return field
}

export function changeLocale(code: string) {
  localStorage.setItem('locale', code)
  window.location.href = urlWithLocaleSubdomain(code)
}

export function urlWithLocaleSubdomain(locale: string) {
  const subdomains = {
    uk: 'ua',
    ru: 'ru',
    en: null
  }

  const subdomain = subdomains[locale]
  const hostname = window.location.host.split('.').slice(-2).join('.')
  const hostWithSubdomain = [subdomain, hostname].filter(i => !!i).join('.')
  const search = new URLSearchParams(window.location.search)
  search.set('lang', locale)
  return window.location.protocol + '//' + hostWithSubdomain + window.location.pathname + '?' + search.toString()
}